import React from "react";
import { X, Loader2, FileIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

const isImage = (file) => file?.file?.type?.startsWith("image/");

export default function TicketFilePreview({ files, onRemove }) {
    const { t } = useTranslation();

    if (!files?.length) return null;

    return (
        <div className="flex flex-wrap gap-2 mb-3">
            {files.map((f) => (
                <div key={f.id} className="relative group border rounded-md p-1.5 flex items-center gap-2 bg-muted/50 max-w-[200px]">
                    {f.status === "uploading" ? (
                        <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />
                    ) : isImage(f) && f.url ? (
                        <img src={f.url} alt={f.name} className="w-8 h-8 object-cover rounded" />
                    ) : (
                        <FileIcon className="w-4 h-4 text-muted-foreground" />
                    )}
                    <span className="text-xs truncate max-w-[120px]">{f.name}</span>
                    {f.status === "completed" && (
                        <button onClick={() => onRemove(f.id)}
                            className="absolute -top-1.5 -right-1.5 bg-destructive text-destructive-foreground rounded-full w-4 h-4 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                            <X className="w-3 h-3" />
                        </button>
                    )}
                    {f.status === "error" && (
                        <span className="text-xs text-destructive">{t("support.createTicket.uploadError", "Upload failed")}</span>
                    )}
                </div>
            ))}
        </div>
    );
}
